import useT from "utils/useT"
import Pill from "./Pill"
import useFiltersStore from "stores/filters"
import { Price } from "types/types"

const FiltersModal = ({ onAccept }: { onAccept: () => void }) => {
  const t = useT()
  const price = useFiltersStore((state) => state.price)
  const setPrice = useFiltersStore((state) => state.setPrice)
  const filters: Price[] = ["all", "free", "discounted", "paid"]
  return (
    <div className="pe-3 ps-3 pt-3 d-grid">
      <h2 dir="auto" className="font-700 mb-4">
        {t.filters.filters}
      </h2>
      <h5 dir="auto">{t.filters.price}</h5>
      <div style={{ direction: t.dir }} className="d-flex pb-4 gap-2 flex-wrap">
        {filters.map((item) => (
          <Pill
            key={item}
            label={t.filters[item]}
            selected={item === price || (item === "all" && !price)}
            onClick={() => setPrice(item)}
          />
        ))}
      </div>
      <div className="d-flex gap-3 mt-3">
        <button
          onClick={() => setPrice("")}
          className="w-100 btn btn-sm btn-full button-s shadow-l rounded-s text-uppercase font-900 bg-blue-dark mb-3"
        >
          {t.filters.reset}
        </button>
        <button
          onClick={onAccept}
          className="w-100 btn btn-sm btn-full button-s shadow-l rounded-s text-uppercase font-900 bg-green-dark mb-3"
        >
          {t.filters.accept}
        </button>
      </div>
    </div>
  )
}

export default FiltersModal
